import React from 'react'
import { Button, Modal, Image, Icon, Label } from 'semantic-ui-react'
import Badge from './Badge'
import ExpanseUser from './ExpanseUser'
import userIcon from '../assets/user-solid.svg'
import { connect } from 'react-redux'

const inlineStyle = {
    modal : {
      marginTop: '0px !important',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    button: {
        border: '1px solid #ffe445',
        color: '#ffe445'
    }
  };


class UserBadge extends React.Component { 
    state = { modalOpen: false, avatarUrl : userIcon }

    componentDidMount() {
        if(this.props.user && this.props.user.exp_user){
            this.setState({avatarUrl:this.props.user.exp_user.avatar})
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user)
            if(this.props.user && this.props.user.exp_user){
                this.setState({avatarUrl:this.props.user.exp_user.avatar})
            }
    }


    handleOpen = () => this.setState({ modalOpen: true })

    handleClose = () => {
        this.setState({ modalOpen: false })
    }
    render(){
        if (!this.props.user.exp_user || this.props.user.is_temporary === 1 ){
            return <Badge icon={this.state.avatarUrl} text={this.props.user.username} />
        }else {
                return (
                <Modal trigger={
                <Button size = 'tiny' onClick ={this.handleOpen} animated='fade' style = {inlineStyle.button}>
                <Button.Content hidden>Pannello Utente</Button.Content>
                    <Button.Content visible>
                                <Icon name='setting' size = "large"/>
                                <Image src={this.state.avatarUrl} avatar/>
                                {this.props.user.username}    
                    </Button.Content>
                    </Button>
                    } style={inlineStyle.modal} open ={this.state.modalOpen}>
                <Modal.Content>
                <ExpanseUser deleteUser = {this.props.deleteUser} onClose = {this.handleClose} gameIsOn ={this.props.gameIsOn}/>
                </Modal.Content>
                </Modal>   
                )   
        }              
    }
      
}

const mapStateToProps = (state) => ({
    user: state.user,
    socket: state.socket
})

const mapDispatchToProps = (dispatch, { socket}) => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserBadge)


// WEBPACK FOOTER //
// ./src/components/UserBadge.js